import { InvoicesList } from "@/features/invoicing/invoices-list/invoices-list";

/**
 * `/stablecoins/invoices` — receivables home (page spec `invoices-list`,
 * design frame INV-00).
 *
 * The route component is a pointer, like every other page in this app: the
 * screen itself lives in `src/features/invoicing/invoices-list/`, wired to
 * `GET /v1/invoices`, `GET /v1/invoice-exceptions?state=OPEN`,
 * `POST /v1/invoices/exports` and `POST /v1/invoices/{id}/duplicate` through the
 * merged invoicing contract client.
 *
 * The `<WipHint />` chip stays until the invoicing service behind these routes
 * exists: the pages read and write the real contract, but every figure they show
 * is honest about the route it came from, and a refusal is rendered rather than
 * worked around.
 */
export default function InvoicesListPage() {
  return <InvoicesList />;
}
